let baseUrl = [
  {
    url: 'https://szwxfs.com/api/',
    desc: '正式',
    is_defaut: true,
  },
]

module.exports = {
  // 基础配置
  BASEURL: baseUrl.filter((item) => item.is_defaut)[0].url,
  // 登录url
  LOGINURL: baseUrl.filter((item) => item.is_defaut)[0].loginUrl,
  // 是否为开发模式
  development: process.env.NODE_ENV == 'development',
  // 端口号
  PORT: 8059,
  // 图片公共地址 搭配 BASEURL使用
  IMGURL: 'sysFileInfo/preview',
  // 是否为测试环境
  ISTEST:
    baseUrl.filter((item) => item.is_defaut)[0].loginUrl ==
    'https://tc.yunweicn.com/testh5/',
}
